import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import './NotFound.scss';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box className="not-found fade-in">
      <Box className="not-found-content">
        <Typography variant="h1" className="error-code">
          404
        </Typography>
        
        <Box className="error-icon">
          ♠
        </Box>
        
        <Typography variant="h3" className="error-title">
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={handleGoHome}
          className="home-button"
        >
          Back to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;